import React from 'react';
import useWindowSize from 'utils/hooks/useWindowSize';
import Image from 'next/image';

import contact_1 from '../../../../../public/images/main/logisticsFinance/question/1.webp';

const ExplainSection = () => {
  const { width } = useWindowSize();

  return (
    <section className="explain-section">
      <div className="container">
        <div className="explain-section__content">
          <div className="explain-section__question">
            <div className="explain-section__question_image-box">
              <Image
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
                className="explain-section__question-image"
                src={contact_1}
                alt="Finance Earth"
              />
            </div>
            <div className="explain-section__question-description">
              <h2 className="explain-section__heading-h2">
                What is {(width > 768 || width <= 568) && <br />}
                DP World Trade Finance?
              </h2>
              <p className="explain-section__question-text">
                DFA Members gain unparalleled access to timely financing. {width <= 768 && <br />} Through DP World
                Trade Finance you can access streamlined processes and cutting-edge technology to{' '}
                <strong> empower your business to be able to seize growth </strong>opportunities without delay.
              </p>
              <p className="explain-section__question-text">
                The comprehensive data analytics available on the platform, enable lenders around the globe to make
                informed {width > 768 && <br />}
                decisions and <strong>provide tailored financial solutions</strong>.
              </p>
              <p className="explain-section__question-text">
                Join us in reshaping the future of trade finance, where {width > 768 && <br />} businesses thrive and
                financing is never a barrier to success.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExplainSection;
